import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("propto_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super admins / developers working inside a society: scope every society API call to it.
  const scope = localStorage.getItem("propto_scope");
  if (scope && (config.url || "").startsWith("/society")) {
    config.params = { society_id: scope, ...(config.params || {}) };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      localStorage.removeItem("propto_token");
      window.location.href = window.location.pathname.startsWith("/developer") ? "/developer/login" : "/login";
    }
    const detail = String(err.response?.data?.detail || "");
    if (err.response?.status === 403 && /suspended/i.test(detail)) {
      localStorage.removeItem("propto_token");
      localStorage.removeItem("propto_scope");
      window.location.href = "/developer/login";
    } else if (err.response?.status === 403 && localStorage.getItem("propto_scope") && /handed over|Not allowed for this society/i.test(detail)) {
      localStorage.removeItem("propto_scope");
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e.response?.data?.detail;
  if (d == null) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;
